__turbopack_context__.v({
  "checkBox": "wvwweG_checkBox",
  "checkMark": "wvwweG_checkMark",
  "customCheckBoxWrapper": "wvwweG_customCheckBoxWrapper",
  "input": "wvwweG_input",
  "inputWrapper": "wvwweG_inputWrapper",
  "label": "wvwweG_label",
  "toolTipWrapper": "wvwweG_toolTipWrapper",
});
